export interface CaptureQuality {
  faceSize: number;
  centerOffset: number;
  yaw: number;
}

export interface CaptureCandidate {
  blob: Blob;
  quality: CaptureQuality;
  score: number;
}

export function captureScore(quality: CaptureQuality): number {
  // 抓拍评分只用于从合格帧中排序，不参与服务端身份匹配结论。
  const sizeScore = Math.min(quality.faceSize / 0.45, 1);
  const centerScore = Math.max(0, 1 - quality.centerOffset / 0.25);
  const poseScore = Math.max(0, 1 - Math.abs(quality.yaw) / 18);
  return sizeScore * 0.4 + centerScore * 0.3 + poseScore * 0.3;
}

export async function captureFaceFrame(video: HTMLVideoElement, quality: CaptureQuality): Promise<CaptureCandidate> {
  if (!video.videoWidth || !video.videoHeight) {
    throw new Error('摄像头画面尚未就绪');
  }
  const canvas = document.createElement('canvas');
  const maxWidth = 1280;
  const scale = Math.min(1, maxWidth / video.videoWidth);
  canvas.width = Math.round(video.videoWidth * scale);
  canvas.height = Math.round(video.videoHeight * scale);
  const context = canvas.getContext('2d', { alpha: false });
  if (!context) throw new Error('浏览器无法创建抓拍画布');
  // Canvas 获取原始相机帧；预览使用的 CSS 镜像不会写入上传图片。
  context.drawImage(video, 0, 0, canvas.width, canvas.height);
  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob((value) => (value ? resolve(value) : reject(new Error('人像编码失败'))), 'image/jpeg', 0.9);
  });
  return { blob, quality, score: captureScore(quality) };
}
